import React, { FunctionComponent, useCallback, useState } from 'react'
import { Pressable, Text, View } from 'react-native'
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons'

import { Dialog } from '../../Dialog'
import { useDemandeAbsenceStyles }  from '../../../modules/DemandeAbsence/DemandeAbsence.styles'

import dayjs from 'dayjs'
import { DemandeAbsenceType } from '../../../api/DemandeAbsence/types'
import { getMimeTypeFromExtension } from '../../../lib/generique'
import ChampModal from '../../ChampModal/ChampModal.component'
import { PdfViewer } from '../../PdfViewer'
import { DocumentApi } from '../../../api/Document'
import { isWeb } from '@commonStyle'
import { useResponsive } from '@hooks'
import { AffichagePeriode } from '../../AffichagePeriode/AffichagePeriode'
import PastilleStatutDemande from '../../StatutDemande/PastilleStatutDemande'

interface DetailDemandeAbsenceProps {
  onClose: () => void
  selectedDemande: DemandeAbsenceType
  handleAnnule: (identifiant: number) => () => Promise<void>
  handleValide: (demande: DemandeAbsenceType) => () => Promise<void>
}

export const DetailDemandeAbsence: FunctionComponent<DetailDemandeAbsenceProps> = ({
  onClose,
  selectedDemande,
  handleAnnule,
  handleValide
}) => {

  const { styles } = useDemandeAbsenceStyles();
  const [fileUri, setFileUri] = useState<string | undefined>(undefined)
  const isResponsive = useResponsive();

  const openPdfViewer = useCallback(() => {
    if(selectedDemande.document) {
      DocumentApi.downloadDocument(selectedDemande.document.identifiant).then((res) => setFileUri(res));
    }
  }, [selectedDemande])

  const renderBoutons = useCallback(() => {
    if (selectedDemande && selectedDemande.statut === 0 && dayjs(selectedDemande.dateDebut).isAfter(dayjs(), 'date')) {
      return (
        <View style={styles.buttonsContainer}>
          <View style={styles.buttonsRow}>
            <Pressable
              style={styles.buttonPrimary}
              onPress={handleValide(selectedDemande)}
              testID='BT_MODIFIER'
            >
              <Text style={styles.buttonText}>Modifier</Text>
            </Pressable>

            <Pressable
              style={styles.buttonSecondary}
              onPress={handleAnnule(selectedDemande.identifiant || 0)}
              testID='BT_SUPPRIMER'
            >
              <Text style={styles.buttonText}>Supprimer</Text>
            </Pressable>
          </View>
        </View>
      )
    }
  }, [handleAnnule, handleValide, selectedDemande, styles])

  if(selectedDemande){
    return (
      <Dialog
        visible={true}
        onClose={onClose}
        title="Détails de la demande"
        fullScreen={true}
      >
        <View style={styles.demandeDetailContainer}>
          <View style={styles.containerPart}>
            <ChampModal title='Type :' content={selectedDemande.natureAbsence?.libelle} />
            <ChampModal title='Période :' content={
            <AffichagePeriode
              dateDebut={selectedDemande.dateDebut}
              dateFin={selectedDemande.dateFin}
              heureDebut={selectedDemande.heureDebut}
              heureFin={selectedDemande.heureFin}
              direction='column'/>}
            />
            <ChampModal title='Durée :' content={selectedDemande.duree?.texte} />

            <View style={styles.detailRow}>
              <Text style={styles.detailLabel}>Statut :</Text>
              <PastilleStatutDemande statut={
                selectedDemande.statut === 0
                  ? "enCours"
                  : selectedDemande.statut === 1
                    ? "acceptee"
                    : "refusee"
                }
              />
              {selectedDemande.prevision === 1 && (
                <View style={styles.statusBadgePrevision}>
                  <MaterialCommunityIcons
                    name="calendar-clock"
                    size={16}
                    color="white"
                  />
                  <Text style={styles.statusText}>
                    Prévision
                  </Text>
                </View>
              )}
            </View>
            {selectedDemande.observations && (<ChampModal title='Observations :' content={selectedDemande.observations} />)}
            {
              // obligation de vérifier pièces jointes de cette manière car c'est un nombre
              selectedDemande?.piecesjointes !== undefined && selectedDemande?.piecesjointes > 0 && selectedDemande.document && (
                <ChampModal
                  title='PJ :'
                  content={
                    <Pressable
                      style={styles.buttonsRow}
                      onPress={openPdfViewer}
                      testID='BT_PJ'
                    >
                      <Text style={styles.piecesJointes}>
                        {selectedDemande.document.libelle}
                      </Text>
                    </Pressable>
                  }
                />
              )
            }
            {selectedDemande.dateDemande && (<ChampModal title='Demande :' content={dayjs(selectedDemande.dateDemande).format('DD/MM/YYYY')} />)}
            {selectedDemande.dateValidation && (<ChampModal title='Validation :' content={dayjs(selectedDemande.dateValidation).format('DD/MM/YYYY')} />)}
            {selectedDemande.dateSuppression && (<ChampModal title='Suppression :' content={dayjs(selectedDemande.dateSuppression).format('DD/MM/YYYY')} />)}
          </View>
          { isWeb
            ? isResponsive
              ? <Dialog
                  visible={selectedDemande?.document && fileUri ? true : false}
                  title={selectedDemande.document?.libelle || ''}
                  horizontal
                  width={'100%'}
                  onClose={() => setFileUri(undefined)}
                >
                  <PdfViewer
                    source={{uri: fileUri}}
                    filename={selectedDemande.document?.libelle}
                    onError={(pdfError) => {
                      console.log('Erreur PdfViewer:', pdfError);
                    }}
                    onFinally={() => setFileUri(undefined)}
                    mimeType={getMimeTypeFromExtension(selectedDemande.document?.extension)}
                  />
                </Dialog>
              : (selectedDemande?.document && fileUri ? true : false) &&
                (
                  <View style={styles.containerPart}>
                    <PdfViewer
                      source={{uri: fileUri}}
                      filename={selectedDemande.document?.libelle}
                      onError={(pdfError) => {
                        console.log('Erreur PdfViewer:', pdfError);
                      }}
                      onFinally={() => setFileUri(undefined)}
                      mimeType={getMimeTypeFromExtension(selectedDemande.document?.extension)}
                    />
                  </View>
                )
            : <PdfViewer
                source={{uri: fileUri}}
                filename={selectedDemande.document?.libelle}
                onError={(pdfError) => {
                  console.log('Erreur PdfViewer:', pdfError);
                }}
                onFinally={() => setFileUri(undefined)}
                mimeType={getMimeTypeFromExtension(selectedDemande.document?.extension)}
              />
          }
        </View>
        {renderBoutons()}
      </Dialog>
    )
  }
}
